import { useState, useEffect } from 'react';

const WHATSAPP_LINK = 'https://wa.me/905321737544?text=Merhaba,%20Google%20reklam%C4%B1ndan%20ula%C5%9F%C4%B1yorum.%20Ak%C3%BC%20/%20yol%20yard%C4%B1m%20veya%20yedek%20par%C3%A7a%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.';
const PHONE_LINK_1 = 'tel:+905321737544';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-brand-dark/90 backdrop-blur-md border-b border-white/10 shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#" className="text-white font-bold text-sm md:text-base tracking-wide uppercase whitespace-nowrap">
            SİLİVRİ OTO YEDEK PARÇA
          </a>

          <div className="flex items-center gap-2 md:gap-3">
            <a
              href={PHONE_LINK_1}
              className="flex items-center gap-2 bg-brand-accent hover:bg-brand-accentHover text-white font-semibold text-sm px-4 py-2.5 rounded-full transition-colors whitespace-nowrap"
            >
              <span className="hidden sm:inline">Hemen Ara</span>
              <span className="sm:hidden">Ara</span>
              <i className="fas fa-phone text-xs"></i>
            </a>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold text-sm px-4 py-2.5 rounded-full transition-colors whitespace-nowrap"
            >
              <span className="hidden sm:inline">WhatsApp</span>
              <i className="fab fa-whatsapp text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}